import React, {useEffect, useState} from 'react'
import MainLayout from '../../components/MainLayout'
import axios from 'axios'
import {
	Link
} from 'react-router-dom';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

type Props = {}

interface SimcardInterface {
    id: number;
    serial: string;
    date_register: string;
    node: string;
    active: boolean;
}

const SimcardList = (props: Props) => {
    const title = "Simcard"
    const [loading, setLoading] = useState(false)
    const [simcards, setSimcards] = useState<Array<SimcardInterface>>([])

    useEffect(() => {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1/simcard").then(res=>{
            setLoading(false)
            setSimcards(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }, [])

    function handleDelete(id:string) {
        setLoading(true)
        if (!window.confirm("Are you sure you want to delete record?")) return
        axiosInstance.delete(`https://api.cl-ds.com/internal/operations/v1/simcard/${id}/`).then(res=>{
            setLoading(false)
            console.log(11, res)
            alert(res.data.message)
            window.location.reload()
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }
    

    return (
            <div className="col-12">
            {loading && ( <Loader/> )}

                <div className="card">
                    <div className="card-body">
                        <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                            <h5 className="card-title">{title} List</h5>
                            <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                                
                                <Link to="/simcard/add" >
                                    <button type="button" className="btn btn-outline-info">Create</button>
                                </Link>
                            </div>

                        </div>


                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Serial</th>
                                    <th scope="col">Date Register</th>
                                    {/* <th scope="col">Node</th> */}
                                    <th scope="col">Active</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {simcards.map( (simcard, index) => {

                                    return (
                                        <tr key={index}>
                                            <th scope="row">{simcard.serial}</th>
                                            <td>{simcard.date_register}</td>
                                            {/* <td>{simcard.node}</td> */}
                                            <td>{simcard.active}</td>
                                            <td>
                                                <Link to={`/simcard/edit/${simcard.id}`} >
                                                    <button type="button" className="btn btn-outline-info"><i className="bi bi-pencil"></i></button>
                                                </Link>
                                                <button type="button" className="btn btn-outline-danger mx-1" onClick={()=>{handleDelete(simcard.id.toString())}}><i className="bi bi-trash"></i></button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    

                    </div>
                </div>

            </div>

    )
}

export default SimcardList